import type { AreaCatalog } from '../area';
import type { connect as en } from '../en/connect';

export const connect = {
  'connect.title': '{app} möchte mit deinem Tesserano arbeiten',
  'connect.summary.write':
    '{app} kann die Aufgaben sehen und ändern, die du sehen kannst, aber sie nicht teilen und nicht ändern, wer sie sieht.',
  'connect.summary.read':
    '{app} kann die Aufgaben sehen, die du sehen kannst, aber sie nicht ändern.',
  'connect.summary.writeUnder':
    '{app} kann die Aufgaben unter {items} sehen und ändern, die du sehen kannst, aber sie nicht teilen und nicht ändern, wer sie sieht.',
  'connect.summary.readUnder':
    '{app} kann die Aufgaben unter {items} sehen, die du sehen kannst, aber sie nicht ändern.',
  'connect.summary.manage':
    '{app} kann die Aufgaben sehen, ändern und teilen, die du sehen kannst, und ändern, wer sie sieht.',
  'connect.summary.manageUnder':
    '{app} kann die Aufgaben unter {items} sehen, ändern und teilen, die du sehen kannst, und ändern, wer sie sieht.',
  'connect.summary.where.groups': 'Nur in {groups}.',
  'connect.summary.where.groupsOwn': 'Nur in {groups} und in deinen eigenen Aufgaben.',
  'connect.summary.where.own': 'Nur in deinen eigenen Aufgaben.',
  'connect.existing':
    'Du hast {app} schon einmal verbunden. Erlauben behält diese Verbindung, mit jeder Änderung, die du hier machst.',
  'connect.replaces':
    'Du hast {app} schon verbunden. Erlauben ersetzt diese Verbindung durch diese hier, und die alte funktioniert nicht mehr.',
  'connect.returnsTo': 'Danach geht es zurück zu {host}.',
  'connect.allow': 'Erlauben',
  'connect.change': 'Ändern',
  'connect.cancel': 'Abbrechen',
  'connect.may.label': 'Was {app} darf',
  'connect.pick.title': 'Wo {app} arbeiten darf',
  'connect.pick.subtitle': '{app} erreicht diese Aufgabe und alles darunter.',
  'connect.pick.search': 'Nach einer Aufgabe suchen',
  'connect.unavailable.title': 'Dieser Link funktioniert nicht mehr',
  'connect.unavailable.body':
    'Geh zurück zu der App, von der du kommst, und verbinde dich noch einmal.',
  'connect.error.expired':
    'Diese Anfrage ist abgelaufen. Geh zurück zur App und verbinde dich noch einmal.',
  'connect.error.onlyPerson': 'Nur eine Person kann einer App etwas erlauben.',
} as const satisfies AreaCatalog<typeof en>;
